import React, { useState } from 'react'
import Icons from '../icons/Icons'

const CollapsableCard = ( { collapsed=true, title='', children } ) => {
    const [ isCollapsed, setIsCollapsed ] = useState( collapsed ) 
    return (
        <div className='msync-card'>
            <div className="msync-card-header">
                <h5>{ title }</h5>
                <div 
                    className='msync-collapse-arrow'
                    onClick={()=>setIsCollapsed(!isCollapsed)}
                >
                {
                    isCollapsed ? (
                        <Icons type='arrow-up' />
                    ) : (
                        <Icons type='arrow-down' />
                    )
                }
                </div>
            </div>
            <div className="msync-card-body">
                {
                    isCollapsed && (
                        children
                    )
                }
            </div>
        </div>
    )
}

export default CollapsableCard
